import i18n from 'i18next';
import moment from 'moment';

import { SURVEY_STATUS } from '~/data/surveys';

import {
  QuestionOption,
  ServerQuestion,
  ServerQuestionOption,
  ServerSurvey,
  SurveyAnswer,
  SurveyQuestion,
} from '../../types';

const getPercentage = (value: number, outOf: number) =>
  `${(Math.round((value * 100) / outOf) || 0).toString()}%`;

export const generateSurvey = (survey: ServerSurvey): SurveyAnswer => {
  const {
    audience,
    reviewers,
    status,
    isPrivate,
    audienceAnswered = 0,
    audienceTotal = 0,
    questions: sQuestions,
  } = survey;

  let questions = [] as SurveyQuestion[];
  if (sQuestions && sQuestions.length > 0) {
    const getOptions = (opts: ServerQuestionOption[]): QuestionOption[] =>
      opts
        .map((opt) =>
          Object.assign({}, opt, { order: opt.index, value: opt.text }),
        )
        .sort((a, b) => a.index - b.index);

    questions = sQuestions
      .map(
        (question: ServerQuestion): SurveyQuestion =>
          Object.assign(
            {},
            question,
            question.options ? { options: getOptions(question.options) } : {},
            {
              typeLabel: i18n.t(`label_${question.type}`),
              order: question.index,
              value: question.text,
            },
          ),
      )
      .sort((a, b) => a.index - b.index);
  }

  let surveyAudience = i18n.t('label_none');
  if (audience && audience.length !== 0) {
    surveyAudience =
      audience.length === 1 && audience[0].name
        ? audience[0].name
        : i18n.t('label_units', { count: audience.length });
  }

  let surveyReviewers = i18n.t('label_none');
  if (reviewers && reviewers.length !== 0) {
    surveyReviewers =
      reviewers.length === 1 && reviewers[0].name
        ? reviewers[0].name
        : i18n.t('label_units', { count: reviewers.length });
  }

  let surveyStatus = '';
  if (status === SURVEY_STATUS.ACTIVE) {
    surveyStatus = survey.closeDate
      ? i18n.t('label_active_closes', {
          date: moment(survey.closeDate).format('DD.MM.YYYY'),
        })
      : i18n.t('label_active_close_not_set');
  } else {
    surveyStatus = i18n.t(`label_${status}`);
  }

  const surveyAnswers = `${audienceAnswered}/${audienceTotal} (${getPercentage(
    audienceAnswered,
    audienceTotal,
  )})`;

  return {
    ...survey,
    surveyStatus,
    questions,
    surveyAudience,
    surveyReviewers,
    isPrivate,
    surveyAnswers,
  };
};
